import { styled } from '@mui/system';
import { ReactNode } from "react";
import { useMediaQuery } from '@mui/material';

interface GridProps {
    children: ReactNode;
    columns?: number;
    rows?: number;
    mobileColumns?: number;
    mobileRows?: number;
    gap?: string;
    mobileGap?: string;
    marginBottom?: string;
    mobileMarginBottom?: string;
}

const GridContainer = styled('div')<{
    columns: number;
    rows: number;
    gap: string;
    marginBottom: string;
}>(({ columns, rows, gap, marginBottom }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gridTemplateRows: `repeat(${rows}, 1fr)`,
    gap: gap,
    marginBottom: marginBottom,
    '@media (max-width: 1024px)': {
        gap: '16px',
        marginBottom: '48px',
        width: '100%',
    }
}));

export const Grid = ({
    children,
    columns = 3,
    rows = 1,
    mobileColumns,
    mobileRows,
    gap = '24px',
    mobileGap = '16px',
    marginBottom = '96px',
    mobileMarginBottom = '48px'
}: GridProps) => {
    const isMobile = useMediaQuery('(max-width:1024px)');

    const effectiveColumns = isMobile && mobileColumns ? mobileColumns : columns;
    const effectiveRows = isMobile && mobileRows ? mobileRows : rows;
    const effectiveGap = isMobile ? mobileGap : gap;
    const effectiveMarginBottom = isMobile ? mobileMarginBottom : marginBottom;

    return (
        <GridContainer
            columns={effectiveColumns}
            rows={effectiveRows}
            gap={effectiveGap}
            marginBottom={effectiveMarginBottom}
        >
            {children}
        </GridContainer>
    );
};
